export default __webpack_public_path__ + "static/media/Sturdy Pirate Ring.3d8fef86.jpg";